import { Component, OnInit } from '@angular/core';
import { GAccsessService } from 'src/app/services/g-accsess.service';
import { UnitsService } from 'src/app/services/units.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GatesService } from 'src/app/services/gates.service';
import { DatePipe } from '@angular/common';
import { PageEvent } from '@angular/material/paginator';
import { environment } from '../../../../environments/environments'
import { trigger , transition , style , animate} from '@angular/animations';
import { MainService } from 'src/app/services/main.service';


@Component({
  selector: 'app-access-list',
  templateUrl: './access-list.component.html',
  styleUrls: ['./access-list.component.css'],
  animations: [
    trigger(
      'fadeInOut', [
        transition(':enter', [
          style({transform: 'translateY(0)', opacity: 0}),
          animate('300ms', style({transform: 'translateY(100%)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateY(100%)', opacity: 1}),
          animate('300ms', style({transform: 'translateY(0)', opacity: 1}))
        ])
      ]
    )
  ],
})
export class AccessListComponent implements OnInit {

  filter_form: FormGroup | any;
  curent_page = 1
  pagesLength = 1
  pageNumber = 0
  pageLimt = 100

  all_gates:any
  all_types:any
  pipe = new DatePipe('en-US');
  access_logs:any = []

  constructor( private rest : GAccsessService , 
    private unitServ : UnitsService,
    private formBuilder: FormBuilder,
    private mainServ : MainService,
    private gateServ : GatesService){}

  ngOnInit(){
    this.initFormFilet()
    this.retriveAccesLog()
    this.Retrive_gats()
    this.retrive_types()
  }
  
  
  initFormFilet(){
    this.filter_form = this.formBuilder.group({
      name: [''],
      access_type: [''],
      message: [''],
      controller_id: [''],
      direction: [''],
      plate_number: [''],
      unit_name: [''],
      registered_to: [''],
      valid_to: [''],
      valid_from: [''],
      charOne: [''],
      charTow: [''],
      charThree: [''],
      number: [''],
    });
  }
  retriveAccesLog(value?:any){
    let data:any
    if(value){
      delete value.number
      delete value.charThree
      delete value.charTow
      delete value.charOne
      Object.keys(value).forEach(key => {
        if (value[key] === '' || value[key] === null) {
          delete value[key];
        }
      });
      value.page = this.curent_page
      value.page_limit = this.pageLimt
      data = value
      console.log(data)
    }else {
       data = {
        page : this.curent_page,
        page_limit : this.pageLimt
      }
    }
  
    this.rest.retiveLogs(data).subscribe((res:any) => {
      this.access_logs = res.access_logs
      this.access_logs.forEach((element:any) => {
        if(element.globalscene){
          element.globalscene = `${environment.baseUrl}/images/logs${element.globalscene }`
        }
        if(element.smallscene){
          element.smallscene = `${environment.baseUrl}/images/logs${element.smallscene }`

        }
        if(element.image){
          element.image = `${environment.baseUrl}/images/logs${element.image }`

        }
      });
      console.log( this.access_logs)
      this.pagesLength = res.total_number
    })
  }

  statusBtn = true
  change_layout(value:any){
    this.statusBtn =! this.statusBtn 
  }

  Retrive_gats(){
    this.gateServ.retriveGates().subscribe((res:any) => {
      console.log(res)
      this.all_gates = res
    })
  }

  retrive_types(){
    this.unitServ.cardType().subscribe((res:any) => {
      console.log(res)
      this.all_types = res.children
    })
  }

  filterData(){
    let data = this.filter_form.value
    data.number =  Intl.NumberFormat('ar-SA',{
    }).format(data.number);
     data.number = data.number.replace('٬','')
     if(data.charThree){
      data.plate_number = data.charThree + ' ' + data.charTow + ' ' +  data.charOne + data.number  
     }
    data.valid_from = this.pipe.transform(data.valid_from, 'YYYY-MM-dd');
    data.valid_to = this.pipe.transform(data.valid_to, 'YYYY-MM-dd');
    console.log(data)
    this.retriveAccesLog(data)
  }

  exportData(){
    let data = this.filter_form.value
    data.number =  Intl.NumberFormat('ar-SA',{
    }).format(data.number);
     data.number = data.number.replace('٬','')
     if(data.charThree){
      data.plate_number = data.charThree + ' ' + data.charTow + ' ' +  data.charOne + data.number  
     }
    data.valid_from = this.pipe.transform(data.valid_from, 'YYYY-MM-dd');
    data.valid_to = this.pipe.transform(data.valid_to, 'YYYY-MM-dd');
    
      delete data.number
      delete data.charThree
      delete data.charTow
      delete data.charOne
      Object.keys(data).forEach(key => {
        if (data[key] === '' || data[key] === null) {
          delete data[key];
        }
      });
      data.page = this.curent_page
      data.page_limit = this.pageLimt
      console.log(data)

      this.rest.exportLogos(data)
      .then(response => response.blob())
      .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'export_file.csv';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
      });
  }

  resetForm(){
    this.filter_form.reset()
    this.retriveAccesLog()
  }

  handlePageEvent(e: PageEvent) {
    this.pageNumber = e.pageIndex
    this.curent_page = e.pageIndex + 1
    this.pageLimt = e.pageSize
    this.retriveAccesLog()
    console.log(e)
  }

  filter_status:any = true

  toggleFilter(){
    this.filter_status = !this.filter_status
  }
}
